/* eslint-disable jsx-a11y/label-has-associated-control */

import React from "react";
import cx from "clsx";
import defVImage from "../../../../_legacy/images/no-image-vertical.png";
import LockProcedure from "../../../Clients/Timeline/LockProcedure";
import { capitalizeFirstLetter, showFormattedDate } from "../../../../Utils";
import styles from "./styles.module.scss";
import { MarkdownContent } from "../../../../shared/MarkdownContent/MarkdownContent";

export const ProcedureRow = ({
  obj,
  idx,
  selected,
  handleInputChange,
  refetchProcedures,
}) => {
  return (
    <div className="table-row">
      <div className="table-cell export-input exportProcedureCheck">
        <input
          className={cx(styles.check, {
            "without-consult-fees":
              obj.template_used === 0 && obj.procedure_type === "health",
          })}
          type="checkbox"
          id={"childCheck_" + idx}
          name={"childCheck_" + idx}
          checked={
            selected.length > 0 &&
            selected[idx] !== undefined &&
            selected[[idx]][obj.id] === true
          }
          onChange={handleInputChange}
          value={obj.id}
        />
      </div>
      {obj.procedure_type === "cosmetic" && (
        <React.Fragment key={idx}>
          <div className="table-cell">
            <label htmlFor={"childCheck_" + idx}>
              <div className="export-pro-image">
                <img
                  key={idx}
                  src={
                    obj.procedure_image_data &&
                    obj.procedure_image_data.patient_image_front_thumb_url
                      ? obj.procedure_image_data.patient_image_front_thumb_url
                      : defVImage
                  }
                  alt=""
                  className={obj.is_lock ? "lockSensitiveProcedureImages" : ""}
                />
              </div>
            </label>
          </div>
          <div className="table-cell">
            <div className="pro-proc-title">{obj.procedure_name}</div>
            <div className="export-pro-time">
              {showFormattedDate(obj.procedure_date, true)}
            </div>
            <span className="juvly-subtitle no-margin">Notes:</span>
            <div className="export-pro-note word-break">
              {!!obj.note && (
                <div className="p-text pro-to-export">
                  <MarkdownContent>{obj.note}</MarkdownContent>
                </div>
              )}
              {obj.procedure_notes &&
                obj.procedure_notes.length > 0 &&
                obj.procedure_notes.map((iobj, iidx) => {
                  return (
                    <div key={iidx} className="p-text pro-to-export">
                      <MarkdownContent>{iobj.notes}</MarkdownContent>
                    </div>
                  );
                })}
            </div>
          </div>
          <div className="table-cell">
            <LockProcedure
              refetchProcedures={refetchProcedures}
              lockUnlockby={obj.locked_unlocked_by}
              isLocked={obj.is_lock}
              procedureId={obj.id}
            />
          </div>
        </React.Fragment>
      )}
      {["health", "exam"].includes(obj.procedure_type) && (
        <React.Fragment key={idx}>
          <div className="table-cell">
            <div className="pro-proc-title">{obj.procedure_name}</div>
            <div className="export-pro-time">
              {showFormattedDate(obj.procedure_date, true)}
            </div>
            <p className="p-text no-margin">
              <b>Provider:</b> {capitalizeFirstLetter(obj.doctor_name)}
            </p>
          </div>
          <div className="table-cell">
            <span className="juvly-subtitle no-margin">Notes:</span>
            <div className="export-pro-note word-break">
              {!!obj.note && (
                <div className="p-text pro-to-export">
                  <MarkdownContent>{obj.note}</MarkdownContent>
                </div>
              )}
              {obj.procedure_notes &&
                obj.procedure_notes.length > 0 &&
                obj.procedure_notes.map((iobj, iidx) => {
                  return (
                    <div key={iidx} className="p-text pro-to-export">
                      <MarkdownContent>{iobj.notes}</MarkdownContent>
                    </div>
                  );
                })}
            </div>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};
